export default __webpack_public_path__ + "static/eric2-426d8a168ac080ccc1e58f8a7024e99a.jpg";